module.exports = __webpack_public_path__ + "img/kn.79727c0e.svg";